import { IFieldSubmissionMap, IFormFieldSubmission } from "@common/redux/formSubmission/interface";
import { IDescriptionFieldConfigurationClient, IDescriptionFieldConfigurationServer } from "./interface";
import { FieldProps,  } from "../FormFieldSelector/interfaces";
import { validateRule } from "../FormTextInputField/rules/utils";
import { RichTextEditorTheme } from "@erelego/design-system/components/atoms/RichTextEditor";

export const transformDescriptionFieldConfigClientToServer = (
  fieldConfigClient: IDescriptionFieldConfigurationClient
): IDescriptionFieldConfigurationServer => {
  const { placeholder, initialValue, writeJavascript, isRichTextEnable,descriptionFieldHeight } = fieldConfigClient;
  const fieldConfigServer = {
    placeHolder: placeholder,
    initialValue: initialValue,
    writeJavascript: writeJavascript,
    isRichTextEnable: isRichTextEnable,
    descriptionFieldHeight:descriptionFieldHeight
  };
  return fieldConfigServer;
};

export const transformDescriptionFieldConfigServerToClient = (
  fieldConfigServer: IDescriptionFieldConfigurationServer
): IDescriptionFieldConfigurationClient => {
  const { placeHolder, initialValue, writeJavascript, isRichTextEnable,descriptionFieldHeight } = fieldConfigServer;
  const fieldConfigClient = {
    placeholder: placeHolder,
    initialValue: initialValue,
    writeJavascript: writeJavascript,
    isRichTextEnable: isRichTextEnable,
    descriptionFieldHeight:descriptionFieldHeight
  };
  return fieldConfigClient;
};

export const validateRichTextDescriptionFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
  const { rules: fieldRules } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;
  const submissionValue =
    (fieldSubmissionValue && fieldSubmissionValue?.value) || "";

  if (fieldRules && submissionValue) {
    for (let index = 0; index < fieldRules.length; index++) {
      const [isValidated, validatationErrorMessage] = validateRule(
        fieldRules[index],
        submissionValue,
        fieldSubmissionMap
      );
      if (!isValidated && validatationErrorMessage !== "") {
        return [isValidated, validatationErrorMessage];
      }
    }
  }

  return [true, ""];
};

export const getComputedReadOnlyMode = ({
  formMode,
  isRichTextEnable,
  descriptionFieldHeight,
  builderMode,
  isViewMode,
  isResponseViewMode,
  isReadOnly,
}: {
  formMode: string;
  isRichTextEnable: boolean;
  descriptionFieldHeight?:string;
  builderMode: boolean;
  isViewMode: boolean;
  isResponseViewMode: boolean;
  isReadOnly: boolean;
}): boolean => {
  if (isResponseViewMode) {
    return true;
  } else if (formMode === FormModes.preview && !isRichTextEnable) {
    return true;
  } else if (builderMode && !isRichTextEnable) {
    return false;
  } else if (isViewMode && !isRichTextEnable) {
    return true;
  } else if (isViewMode) {
    return false;
  } else if (isRichTextEnable) {
    return false;
  } else {
    return isReadOnly;
  }
};

export const getEditorTheme = ({
  formMode,
  isRichTextEnable,
  builderMode,
  description,
}: {
  formMode: string;
  isRichTextEnable: boolean;
  builderMode: boolean;
  description?: string;
}): RichTextEditorTheme => {
  if (formMode === FormModes.preview && !isRichTextEnable) {
    return RichTextEditorTheme.BUBBLE;
  } else if (formMode === FormModes.view && !isRichTextEnable) {
    return description && description !== ""
      ? RichTextEditorTheme.BUBBLE
      : RichTextEditorTheme.SNOW;
  } else if (isRichTextEnable) {
    return RichTextEditorTheme.SNOW;
  } else if (!builderMode) {
    return RichTextEditorTheme.BUBBLE;
  } else {
    return RichTextEditorTheme.SNOW;
  }
};


export const getFormModesFromPath = (formMode: string) => {
  return {
    isFormEditResponse: formMode === FormModes.edit,
    builderMode: formMode === FormModes.edit || formMode === FormModes.preview,
    submission: formMode === FormModes.responseView,
  };
};

export enum FormModes {
  view = "VIEW",
  edit = "EDIT",
  preview = "PREVIEW",
  responseView = "RESPONSEVIEW",
  viewLock = "VIEWLOCK",
}

export enum FormBuilder {
  builder = "form-builder"
}